import {
  LEGAL_DOCUMENT_VIEWER_MODAL_TITLE_PRIVACY,
  LEGAL_DOCUMENT_VIEWER_MODAL_TITLE_TERMS,
} from '@/core/presentation/constants/legal-document-viewer-copy';

export const LEGAL_ADMIN_PAGE = {
  TERMS_TITLE: LEGAL_DOCUMENT_VIEWER_MODAL_TITLE_TERMS,
  TERMS_SUBTITLE: 'Versão exibida aos usuários e histórico de alterações.',
  PRIVACY_TITLE: LEGAL_DOCUMENT_VIEWER_MODAL_TITLE_PRIVACY,
  PRIVACY_SUBTITLE: 'Versão exibida aos usuários e histórico de alterações.',
} as const;

export const LEGAL_ADMIN_PUBLISH_CHANGE_NOTES = 'Publicação via painel admin.';

export const LEGAL_ADMIN_UI = {
  NEW_VERSION: 'Nova versão',
  VIEW_HISTORY: 'Ver histórico',
  HIDE_HISTORY: 'Ocultar histórico',
  SAVE: 'Salvar',
  SAVE_LOADING: 'Publicando',
  CANCEL: 'Cancelar',
  CURRENT_VERSION_PREFIX: 'Versão atual:',
  NEW_VERSION_TITLE: (label: string) => `Nova versão (${label})`,
  DRAFT_HINT: 'Edite o texto abaixo. Nada é publicado até você salvar.',
  HISTORY_TITLE: 'Versões anteriores',
  HISTORY_EMPTY: 'Não há versões anteriores.',
  HISTORY_TOGGLE_OPEN: 'Mostrar conteúdo',
  HISTORY_TOGGLE_CLOSE: 'Ocultar conteúdo',
  BADGE_NO_REACCEPT: 'Sem reaceitação',
  BADGE_REQUIRES_REACCEPT: 'Requer reaceitação',
  CREATED_AT: 'Criado em:',
  UPDATED_AT: 'Atualizado em:',
  CREATED_BY: 'Criado por:',
  UPDATED_BY: 'Atualizado por:',
  CONTENT_LABEL: 'Conteúdo',
  TOAST_SAVED: 'Nova versão salva e publicada como atual.',
} as const;
